import { Link as RouterLink } from 'react-router-dom';
import styled from 'styled-components/macro';
import css from '@styled-system/css';

import modularScale from 'styles/helpers/modular-scale';
import H1 from '../../elements/h1';
import { ThemeProps } from 'types/styled';

const Link = styled(RouterLink)`
  display: flex;
  flex: 0 0 auto;
  background-color: ${({ theme }): string => theme.VeryLightGrey};
  ${css({ p: 2, width: '100%' })};
  transition: ${({ theme }): string =>
    `background ${theme.transitionDuration} ${theme.timingFunction}`};
  &:hover {
    background-color: ${({ theme }): string => theme.LightGrey};
  }
`;

export const Heading = styled(H1)<ThemeProps<'h1'>>`
  font-weight: 600;
  font-size: ${modularScale(2)};
  word-break: break-word;
  /* start - truncate 2 lines */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  /* end */
  margin: 0;
  ${Link}:hover & {
    text-decoration: underline;
  }
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
